import { httpAuthorized } from "@/main";
import { User } from "@/types/user";
import { handleRequest } from "..";

export const fetchUserListApi = async (
  orgId: string
): Promise<User[] | null> => {
  return handleRequest<User[]>(
    httpAuthorized.get("/user/getUserList", { params: { orgId } }),
    (data) => data.data.userList
  );
};

export const fetchUserByIdApi = async (
  userId: string
): Promise<User | null> => {
  return handleRequest<User>(
    httpAuthorized.get("/user/getUserById", { params: { userId } }),
    (data) => data.data.user
  );
};

export const createUserApi = async (user: User): Promise<boolean | null> => {
  return handleRequest<boolean>(
    httpAuthorized.post("/user/createUser", user),
    (data) => data.data.result
  );
};
